// @ts-check
import RoleMenuItem from './menu-item.js';

RoleMenuItem.define('role-menu-item');

export default RoleMenuItem;
export * from './menu-item.js';

/**
 * @type {import("./menu-item-globals.js")}
 */
